export { default } from './FreeTrialView';



// WEBPACK FOOTER //
// ./src/components/views/FreeTrialView/index.js